import { Component, OnInit } from '@angular/core';
import { UserManagementServiceService } from '../user-management-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from 'src/app/shared/snack-bar/snack-bar.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-user-policies',
  templateUrl: './user-policies.component.html',
  styleUrls: ['./user-policies.component.scss']
})
export class UserPoliciesComponent implements OnInit {

  public permissionDetails: any = [];
  public userForm !: FormGroup ;
  userRoles: any = [{name: 'IP', value: 'ip'}];
  roleId = '';
  adminData: any = sessionStorage.getItem('userdata');
  public allowedMessage = 'Role Creation or Update don`t use Number & Special Characters(!,@,#,$,%,^,&,* ...) !!';
  currentMode: any = 'edit';
  userMasterLevel: any;
  selectedLevel: any = '';
  roleLevelId: any;
  constructor(
    private userManagementServiceService: UserManagementServiceService,
    private snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,

  ) { this.getMasterLevel(); }
  public roleName = '';
   ngOnInit(): void {
    this.route.queryParams.subscribe(queryParams => {
      this.currentMode = queryParams?.mode;

    });

    this.adminData = JSON.parse(this.adminData);
    this.roleId = this.route.snapshot.params.id;
    if (this.roleId){
        this.getRoleBasedOnId(this.roleId);
    }else{
        this.getUserLevelPerrmissonData();
    }
  }
  getMasterLevel(): void {
    this.userManagementServiceService.getMasterLevel().subscribe((res: any) => {
      this.userMasterLevel = res?.data;
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , '');
    });
  }

  getUserLevelPerrmissonData(): void {
    this.userManagementServiceService.getUserPermission().subscribe((res: any) => {
      const selfPermission: any = JSON.parse(sessionStorage.getItem('userPermission') || '[]');
      let filteredPermission: any = selfPermission[0].authenicationJson.filter(
        (item: any) => item.authentication.some((auth: any) => auth.isAction === true)
      );
      filteredPermission = filteredPermission && filteredPermission.length ? filteredPermission.map((module: any) => module.model) : [];
      this.permissionDetails = JSON.parse(JSON.stringify(res.data));
      if (this.adminData?.userlevel_id !== 1){
          this.permissionDetails = this.permissionDetails.filter((permission: any) => filteredPermission.includes(permission.model));
          this.permissionDetails.forEach((element: any) => {
            let selfAction: any = selfPermission[0].authenicationJson.find((self: any) => self.model === element.model);
            selfAction = selfAction.hasOwnProperty('model') ? selfAction.authentication.filter((action: any) => action.isAction) : [];
            selfAction = selfAction?.length ? selfAction.map((ele: any) => ele.key) : [];
            element.authentication =  element.authentication.filter((action: any) => selfAction.includes(action.key));

          });
        }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , '');
    });
  }
  isCheckedModule(module: any): any {
    if (module.authentication && module.authentication.length > 0 && module.authentication.every((item: any) => item.isAction)) {
        module.isAction = true;
        module.is_checked = true;
    } else {
        module.isAction = false;
        module.is_checked = false;
    }
}
isIndeterminateModuleOver(module: any): boolean {
  return (
      module.authentication &&
      module.authentication.length &&
      module.authentication.some((data: any) => data.isAction) &&
      !module.authentication.every((data: any) => data.isAction)
  );
}
onModuleChange(event: any, module: any): void {
  if (event) {
    module.isAction = event.checked;
    module.is_checked = event.checked;
    module.authentication.map((item: any) => {
          item.isAction = event.checked;
      });
  }
}
onActionChange(event: any, page: any, selectedData: any): void {
  if (
    (page.authentication.length === 0 && page.isAction) ||
    (page.authentication.length && page.authentication.every((item: any) => item.isAction))
) {
    page.isAction = true;
} else {
    page.isAction = false;
}
}
selectAll(event: any): void {
  event.checked = this.roleId ? !event.checked : event.checked;
  if (event.checked) {
      this.permissionDetails = this.permissionDetails?.map((item: any) => {
          item.isAction = this.roleId  ? !event.checked : event.checked;
          item.is_checked = this.roleId  ? !event.checked : event.checked;
          if (item && item?.authentication && item?.authentication?.length) {
              item?.authentication?.map((innnerItem: any) => {
                  innnerItem.isAction = this.roleId  ? !event.checked : event.checked;
              });
          }
          return item;
      });
  } else {
      this.permissionDetails = this.permissionDetails?.map((item: any) => {
          item.isAction = this.roleId ? !event.checked : event.checked;
          item.is_checked = this.roleId  ? !event.checked : event.checked;
          if (item && item?.authentication && item?.authentication?.length) {
              item?.authentication?.map((innnerItem: any) => {
                  innnerItem.isAction = this.roleId  ? !event.checked : event.checked;
              });
          }
          return item;
      });
  }
}

createRole(): void{
  const ipsaIndex = this.permissionDetails.findIndex((permission: any) => permission.model === 'ipsa');
  if (ipsaIndex === -1){
    const ipsaPermission = {
      model: 'ipsa',
      label: 'PRISM',
      authentication: [
          {
              key: 'createui',
              label: 'Create',
              isAction: false
          },
          {
              key: 'list',
              label: 'List',
              isAction: false
          },
          {
              key: 'update',
              label: 'Update',
              isAction: false
          },
          {
              key: 'report',
              label: 'Report',
              isAction: false
          },
          {
              key: 'submissionlist',
              label: 'Report Submisson List',
              isAction: false
          }
      ],
      is_checked: false,
      isAction: false
  };

    this.permissionDetails.push(ipsaPermission);
  }

  this.permissionDetails.forEach((form: any) => {
    form.authentication.forEach((auth: any) => {
      if (auth?.isAction) {
        const index = form.authentication.findIndex((a: any) => a.key === 'list' || a.key === 'listui');

        if (index !== -1) {
          form.authentication[index].isAction = true;  // Update isAction to false
        }
      }
    });
  });
  let payload: any = {
    role_name: this.roleName,
    authenicationJson : this.permissionDetails,
    userlevel_id: this.selectedLevel,
    ...!(this.roleId) && {createdBy : this.adminData ? this.adminData?.id : ''}
};
  if (this.roleId){
  payload = {...payload, role_id: this.roleLevelId};
  this.updateRole(payload);
}else{
this.userManagementServiceService.createRole(payload).subscribe((res: any) => {
    if (res.success){
      this.openSnackBar([res?.message || 'Success !'] , '', 'success');
    }
    this.router.navigate(['/user-level']);
  }, (error: any) => {
    this.openSnackBar([error?.message || 'Failed !'] , '');
  });
}

}
updateRole(payload: any): void{
    this.userManagementServiceService.updateUserRole(payload, this.roleId).subscribe((res: any) => {
        if (res.success){
          this.openSnackBar([res?.message || 'Success !'] , '', 'success');
        }
        this.router.navigate(['/user-level']);
      }, (error: any) => {
        this.openSnackBar([error?.message || 'Failed !'] , '');
      });

}
isDisabled(): boolean{
    return !(
      this.permissionDetails.some((el: any) => el?.isAction || el?.authentication?.some((e: any) => e?.isAction)) &&
      this.roleName &&
      this.selectedLevel
    );
}

async getRoleBasedOnId(roleId: string): Promise<void> {
    await this.userManagementServiceService.getRoleDataById(roleId).subscribe((res: any) => {
      if (res.success){
        res = JSON.parse(JSON.stringify(res.data[0]));
        if (res){
            this.roleName = res['role.name'] ? res['role.name'] : 'name not availabe';
            this.selectedLevel = res.userlevel_id;
            this.roleLevelId = res.role_id;
            this.permissionDetails = res.authenicationJson;
        }else{
          this.openSnackBar(['Data Not Available !'] , '', 'info');
          return;
        }

      }
    }, (error: any) => {
      this.openSnackBar([error?.message ? error?.message : error?.data || 'Failed !'] , '');
    });
  }
  isModuleOver(item: any): boolean{
   return item?.length && item?.authenicationJson?.length &&  item?.authenicationJson.every((el: any) => (el?.is_checked || el?.isAction));
  }

  openSnackBar(message: any, action = '', className= 'parmary'): void {
    this.snackBar.open(message, action, {
    duration: 3000,
    panelClass: [className]
  });
  }
  preventKeyboardInput(event: KeyboardEvent): void {
    if (event) {
    return;
    }
  }
  selectRole(selectedValue: any): void {
    }

}
